import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Import compat for backward compatibility with existing code
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBuJJOHMK6_RXCMB3rVOKLmzyb-AowxB6c",
  authDomain: "saloon-acaed.firebaseapp.com",
  projectId: "saloon-acaed",
  storageBucket: "saloon-acaed.appspot.com",
  messagingSenderId: "664836267275",
  appId: "1:664836267275:web:e7245968aa614c682f560e",
  measurementId: "G-52BNX17L58"
};

// Initialize Firebase (modular SDK)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize compat for existing code
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Export modular SDK instances
export const auth = firebase.auth();
export const db = firebase.firestore();
// Use new storage bucket URL like main app
export const storage = getStorage(app, 'gs://saloon-acaed.firebasestorage.app');

export default firebase; 